import Vue from 'vue'
import axios from 'axios'
import User from './auth'

const client = axios.create({
  baseURL: '/',
  json: true,
})

export default {
  async execute(method, resource, data) {
    // inject the accessToken for each request
    // let accessToken = await Vue.prototype.$auth.getAccessToken()
    return client({
      method,
      url: resource,
      data,
      headers: {
        // Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(
      success => {
        console.log(success)

        return {
          success: success,
          data: success.data,
        }
      },
      error => {
        console.log(error)

        if (error.response.status === 401) {
          User.cleanUserData()
          window.location.href = '/signin'

          throw {
            error: error,
            message: 'Access allowed only for registered users.', 
          }
        }

        // try found error message
        var errorMessage = 'Error on the server side, try again later.'
        if ((((error.response || {}).data || {}).message || {}).message) {
          errorMessage = error.response.data.message.message
        } else if ((((error.response || {}).data || {}).error || {}).message) {
          errorMessage = error.response.data.error.message
        } else if (((error.response || {}).data || {}).error) { 
          errorMessage = error.response.data.error
        } else if (((error.response || {}).data || {}).message) {
          errorMessage = error.response.data.message
        }

        throw {
          error: error,
          message: errorMessage,
        }
      }
    )
  },

  // api for User
  signIn(email, password) {
    var data = {
      email: email,
      password: password,
    }

    return this.execute('post', '/login', data).then(response => {
      console.log("signIn")
      if (response.data) {
        User.setUserData(response.data.user)
        // window.location.href = '/dashboard'
      }

      return response
    })
  },
  signOut() {
    return this.execute('get', '/api/logout').then(response => {
      User.cleanUserData()
      window.location.href = '/'
    })
  },
  myProfile() {
    return this.execute('get', '/api/my_profile').then(response => {
      if (response.data) {
        User.setUserData(response.data.results.user)
      }

      return response
    })
  },
  myProfileSmallInfo() {
    return this.execute('get', '/api/myProfileSmallInfo')
  },

  getBep20(address) {
    return this.execute('get', '/api/get_bep20/'+address)
  },

  updateProfile({ fullName, phone, title, image, address, city, country, zipcode, state, contact, emailContact, password, walletAddress, walletAddressGREEN, walletGREENBEP20, creditCard, paypal, typeOfProfile }) {
    var data = new FormData()
    if (image) data.append('avatar', image)
    data.append('fullName', fullName)
    data.append('address', address)
    data.append('city', city)
    data.append('title', title)
    data.append('phone', phone)
    data.append('typeOfProfile', typeOfProfile),
    data.append('zipcode', zipcode)
    data.append('state', state)
    data.append('country', country)
    data.append('contact', contact)
    data.append('emailContact', emailContact)
    data.append('password', password)
    data.append('walletAddressGREEN', walletAddressGREEN)
    data.append('walletGREENBEP20', walletGREENBEP20)


    return this.execute('put', '/api/my_profile', data).then(response => {
      if (response.data) {
        User.setUserData(response.data.results)
      }

      return response
    })
  },

  updatePassword({ passwordOld, password }) {
    var data = new FormData()
    data.append('passwordOld', passwordOld)
    data.append('password', password)

    return this.execute('post', '/api/change_password', data).then(response => {
      // if (response.data) {
      //   User.setUserData(response.data.results)
      // }

      return response
    })
  },

  // Payment Methods
  getPaymentMethods() {
    return this.execute('get', '/api/get_payment_methods')
  },

  addPaymentMethod( methods ) {
    var data = new FormData()
    data.append('data', methods)

    return this.execute('post', '/api/add_payment_method', data).then(response => {
      // if (response.data) {
      //   User.setUserData(response.data.results)
      // }

      return response
    })
  },
  updatePaymentMethods( methods ) {
    console.log("methods**************************")
    console.log(methods)
    var data = new FormData()

    data.append('data', methods.data)

    return this.execute('post', '/api/edit_payment_method', data).then(response => {
      // if (response.data) {
      //   User.setUserData(response.data.results)
      // }

      return response
    })
  },
  removePaymentMethod({method, idx}) {
    var data = new FormData()

    data.append('name', method)
    data.append('idx', idx)

    return this.execute('post', '/api/remove_payment_method', data).then(response => {
      // if (response.data) {
      //   User.setUserData(response.data.results)
      // }

      return response
    })
  },


  getUserByToken(token) {
    return this.execute('get', '/api/getUserByToken/' + token)
  },

  updateCities( cities ) {
    var data = new FormData()

    data.append('cities', cities)

    return this.execute('post', '/api/update_cities_weather', data).then(response => {
      // if (response.data) {
      //   User.setUserData(response.data.results)
      // }

      return response
    })
  },

  // Registration Company
  setCompany(data) {
    return this.execute('post', '/api/company', data)
  },

  confirmCompany(data) {
    return this.execute('post', '/api/confirm_company', data)
  },

  // Update Permission for User
  setPermission(data) {
    return this.execute('post', '/api/updateRoleUser', data)
  },

  // api for getBalance
  /*
    {
      "balance": [
          "14.629", - это ETH
          "0"   - это GNET
      ]
    }
  */
  getBalance(addressETH) {
    return this.execute('get', '/api/getBalance/' + addressETH)
  },

  // api for Project
  getAllProjects() {
    return this.execute('get', '/api/allprojects')
  },
  getProjectsByUserId() {
    return this.execute('get', '/api/getprojectsbyuser')
  },
  getProjects({ text, country, city, numberPage, limit, type, my, cc }) {
    return this.execute(
      'get',
      '/api/projects/search?' +
        'text=' +
        text +
        '&country=' +
        country +
        '&city=' +
        city +
        '&page=' +
        numberPage +
        '&limit=' +
        limit +
        '&type=' +
        type +
        '&my=' +
        my +
        '&cc=' +
        cc
    )
  },
  getFundProjects({ text, numberPage, limit, type, theme, continent, country, my }) {
    return this.execute(
      'get',
      '/api/fundprojects/search?' +
        'text=' +
        text +
        '&page=' +
        numberPage +
        '&limit=' +
        limit +
        '&theme=' +
        theme +
        '&continent=' +
        continent +
        '&country=' +
        country +
        '&my=' +
        my
    )
  },
  getTradeOfCO2({ text, numberPage, limit, type }) {
    return this.execute(
      'get',
      '/api/tradeofco2/search?' +
        'text=' +
        text +
        '&page=' +
        numberPage +
        '&limit=' +
        limit +
        '&type=' +
        type
    )
  },
  addWallet(formData) {
    return this.execute('post', '/api/addwallet/', formData)
  },
  saveGREEN(formData) {
    return this.execute('post', '/api/save_get_green/', formData)
  },
  getFundById(projectId) {
    return this.execute('get', '/api/fund/' + projectId)
  },
  addFundProject(formData) {
    return this.execute('post', '/api/fund/addproject/', formData)
  },
  editFundProject(formData) {
    return this.execute('post', '/api/fund/editproject/', formData)
  },
  getHighlightProjects() {
    return this.execute('get', '/api/highlight/')
  },
  getProjectById(projectId) {
    return this.execute('get', '/api/getproject/' + projectId)
  },
  confirmedOwnerProjectById(projectId) {
    return this.execute('post', '/api/confirmedOwner/' + projectId)
  },
  getFundProjectById(projectId) {
    return this.execute('get', '/api/getproject/' + projectId)
  },
  getSystemsDetailById(projectId) {
    return this.execute('get', '/api/getsystemsdetailbyproject/' + projectId)
  },
  getSolarpet(projectId) {
    return this.execute('get', '/api/getsolarpet/' + projectId)
  },
  getSolarpetLine(projectId) {
    return this.execute('get', '/api/inv_chart')
  },
  addProject(formData) {
    return this.execute('post', '/api/addproject/', formData)
  },
  editProject(formData) {
    return this.execute('post', '/api/editproject/', formData)
  },
  getCountProjectsById(projectId) {
    return this.execute('get', '/api/countprojects/' + projectId)
  },
  addLiked(projectId) {
    return this.execute('post', '/api/addliked/' + projectId)
  },
  unLiked(projectId) {
    return this.execute('delete', '/api/unliked/' + projectId)
  },
  setProjectSignatureForNda(projectId, imgeSign) {
    var formData = new FormData()
    formData.append('id', projectId)
    formData.append('imgesign', imgeSign)

    return this.execute('post', '/api/saveSigned', formData)
  },
  setProjectSignatureForAgree(projectId) {
    var formData = new FormData()
    formData.append('id', projectId)

    return this.execute('post', '/api/saveAgree', formData)
  },
  addPostToProject(formData) {
    return this.execute('post', '/api/addpost', formData)
  },
  editPostInProject(formData) {
    return this.execute('put', '/api/editPost', formData)
  },
  sendFundsProject(id, formData) {
    return this.execute('put', '/api/fundProjects/sendFunds/' + id, formData)
  },
  removePostInProject(postId) {
    return this.execute('delete', '/api/removePost/' + postId)
  },
  sendMonthlyReportForExistingProjects({ projectId, produced, month, year, report }) {
    var formData = new FormData()
    formData.append('produced', produced)
    formData.append('month', month)
    formData.append('year', year)

    for (
            var index = 0;
            !(!(index < report.length) || !(index < 5)); // Upload 5 images or less
            index++
          ) {
            formData.append('report', report[index])
          }

    // formData.append('report', report)

    return this.execute(
      'post',
      '/api/project/existing/sendmonthlyreport/' + projectId,
      formData
    )
  },

  // Service
  createService(formData) {
    return this.execute('post', '/api/addproduct/', formData)
  },
  editService(formData) {
    return this.execute('post', '/api/editproduct/', formData)
  },

  // Product
  createProduct(formData) {
      console.log("formData>>>>>>>>>>>>>>>>>>>>>>>")
      console.log(formData)

    return this.execute('post', '/api/addproduct/', formData)
  },
  editProduct(formData) {
    return this.execute('post', '/api/editproduct/', formData)
  },
  getAllProducts() {
    return this.execute('get', '/api/getproducts')
  },
  getProducts({ text, numberPage, limit, type }) {
    return this.execute(
      'get',
      '/api/products/search?' +
        'text=' +
        text +
        '&page=' +
        numberPage +
        '&limit=' +
        limit +
        '&type=' +
        type
    )
  },
  getProductById(productId) {
    return this.execute('get', '/api/getproduct/' + productId)
  },

  // api fro Reviews (Opinion)
  createReviews(productId, title, description, countStar) {
    var formData = new FormData()
    formData.append('product', productId)
    formData.append('title', title)
    formData.append('description', description)
    formData.append('countStar', countStar)

    return this.execute('post', '/api/addopinion', formData)
  },
  getReviews(productId) {
    return this.execute('get', '/api/getopinions' + productId)
  },

  // api fro QuestionsAnswers (Comment)
  createQuestionsAnswers(productId, description, parentId = '0') {
    var formData = new FormData()
    formData.append('product', productId)
    formData.append('title', description)
    formData.append('description', description)
    formData.append('parentId', parentId)

    return this.execute('post', '/api/addcomment', formData)
  },

  // api for Order
  addOrder(order) {
    return this.execute('post', '/api/addorder', order)
  },
  // api for Order
  addPPOrder(order) {
    return this.execute('post', '/buy', order)
  },
  // api for Order
  getAmount(products) {
    return this.execute('post', '/api/getAmountForGNET', { products: products })
  },

  contactMe(serviceId) {
    return this.execute('get', '/api/addService/' + serviceId)
  },

  addStripeOrder(order) {
    return this.execute('post', '/api/addstripeorder', order)
  },

  // api for Order
  checkOrderBTC(orderId) {
    return this.execute('get', '/checkOrderBTC?id=' + orderId)
  },

  // api for Order
  checkOrderETH(orderId) {
    return this.execute('get', '/checkOrderETH?id=' + orderId)
  },

  // api for Order
  checkOrderSLR(orderId) {
    return this.execute('get', '/checkOrderSLR?id=' + orderId)
  },

  // api Order cancelled
  cancelOrder(orderId) {
    return this.execute('get', '/api/cancel/' + orderId)
  },

  // api Send Info about Project
  sendInfoProject(projectId) {
    return this.execute('get', '/api/sendInfoProject/' + projectId)
  },

  // api Order unpaid
  unpaidOrder(orderId, err) {
    return this.execute('post', '/api/unpaid/', {"orderId": orderId, "statusMessage": err})
  },

  successPayPP(paymentId, token, PayerID) {
    return this.execute(
      'get',
      '/success?' +
        'paymentId=' +
        paymentId +
        '&token=' +
        token +
        '&PayerID=' +
        PayerID
    )
  },

  errPayPP(token) {
    return this.execute('get', '/err?' + 'token=' + token)
  },
  saveWalletGREEN(data) {
    return this.execute('post', '/api/completeSocAuth', data) 
  },

  saveStakedToken(data) {
    return this.execute('post', '/api/saveDiscount', data) 
  },

  // api for user Update for addProject
  updateUserData(userData)
  {
    return this.execute('put', '/api/update_user_address', userData)
  },
  sendContactForm(userData)
  {
    return this.execute('post', '/api/sendcontactform', userData)
  },
  updateGreenWallet({ walletAddressGREEN, isOne }) {
    var data = new FormData()
    if (isOne)
      data.append('walletAddressGREEN', walletAddressGREEN)
    else
      data.append('walletGREENBEP20', walletAddressGREEN)

    return this.execute('put', '/api/update_green', data).then(response => {
      if (response.data) {
        User.setUserData(response.data.results)
      }

      return response
    })
  },
  checkPassword(data)
  {
    return this.execute('post', '/login', data).then(response => {    
      return response
    })
  }  

  /* Samples
    getPosts () {
        return this.execute('get', '/posts')
    },
    getPost (id) {
        return this.execute('get', `/posts/${id}`)
    },
    createPost (data) {
        return this.execute('post', '/posts', data)
    },
    updatePost (id, data) {
        return this.execute('put', `/posts/${id}`, data)
    },
    deletePost (id) {
        return this.execute('delete', `/posts/${id}`)
    }*/
}



// WEBPACK FOOTER //
// ./src/services/api.js